/* CRO 2026-10 */
(function () {
  /* 1) Clarity: häufigste JS-Fehler entschärfen */
  if (typeof window._autofillcallbackhandler === 'undefined') {
    window._autofillcallbackhandler = function () {};
  }
  window.addEventListener('error', function (e) {
    if (e && e.message && /ResizeObserver loop/.test(e.message)) {
      e.stopImmediatePropagation();
    }
  });

  /* 2) Trust-Badges: Info-Pop-up (snippets/trust-badges.liquid) */
  function openBadge(key) {
    var d = document.getElementById('cro-badge-dialog');
    if (!d || typeof d.showModal !== 'function') return;
    [].forEach.call(d.querySelectorAll('[data-cro-section]'), function (s) {
      s.hidden = s.getAttribute('data-cro-section') !== key;
    });
    if (!d.open) d.showModal();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cro-badge]');
    if (t) { openBadge(t.getAttribute('data-cro-badge')); return; }
    var d = document.getElementById('cro-badge-dialog');
    if (d && d.open && (e.target === d || (e.target.closest && e.target.closest('.cro-badge-dialog__close')))) d.close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('[data-cro-badge]');
    if (t) { e.preventDefault(); openBadge(t.getAttribute('data-cro-badge')); }
  });

  /* 3) Meistgekaufte Laenge vorwählen (Daten: snippets/cro-length-defaults.liquid) */
  function preselectLength() {
    var cfg = window.CRO_LENGTH_DEFAULTS;
    if (!cfg || /[?&]variant=/.test(location.search)) return;
    var t = (window.CRO_PRODUCT_TITLE || '').toLowerCase();
    var target = cfg.products[t] || cfg.models[t.split(' ')[0]];
    if (!target) return;
    var labels = [].slice.call(document.querySelectorAll('.product-options--root .radios--value-button')).filter(function (l) {
      return /^L\d{2}$/.test((l.getAttribute('data-text') || '').trim());
    });
    if (!labels.length) return;
    var current = labels.filter(function (l) { var i = l.querySelector('input'); return i && i.checked; })[0];
    var want = labels.filter(function (l) { return l.getAttribute('data-text').trim() === target; })[0];
    if (!want || want === current || want.getAttribute('data-unavailable') === 'true') return;
    want.click();
    setTimeout(function () {
      var b = document.querySelector('.product-buy-buttons--primary');
      if (b && b.disabled && current) current.click();
    }, 700);
  }

  /* 4) Empfehlungen: aktuelles Produkt entfernen, auf 4 Karten kürzen */
  function trimRelated() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    var cont = document.querySelector('.related-products--root [data-products-container]');
    if (!m || !cont) return;
    var cards = [].slice.call(cont.children);
    cards.forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]');
      if (a && a.getAttribute('href').indexOf('/products/' + m[1]) !== -1) c.remove();
    });
    cards = [].slice.call(cont.children);
    for (var i = 4; i < cards.length; i++) cards[i].remove();
  }
  function watchRelated() {
    var cont = document.querySelector('.related-products--root [data-products-container]');
    if (!cont) return;
    trimRelated();
    new MutationObserver(function () { trimRelated(); }).observe(cont, { childList: true });
  }

  /* 5) Cookie-Banner: Text kürzen (Shopify-Standardtext ist lang; Datenschutz-Link bleibt erhalten) */
  function shortenBanner() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    if (b.getAttribute('data-cro-short')) return true;
    var p = b.querySelector('.shopify-pc__banner__body p');
    if (!p) return false;
    var de = (document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0;
    var txt = de
      ? 'Wir nutzen Cookies für Funktionen, Statistik und Werbung – nur mit deiner Zustimmung. '
      : 'We use cookies for features, analytics and advertising – only with your consent. ';
    [].slice.call(p.childNodes).forEach(function (n) {
      if (n.nodeType === 3) n.parentNode.removeChild(n);
    });
    p.insertBefore(document.createTextNode(txt), p.firstChild);
    b.setAttribute('data-cro-short', '1');
    return true;
  }
  function watchBanner() {
    if (shortenBanner()) return;
    var obs = new MutationObserver(function () { if (shortenBanner()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  function init() {
    setTimeout(preselectLength, 300);
    watchRelated();
    watchBanner();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
